import React, { useState } from "react";
import styles from './LoginForm.module.scss';
import Logo from "../logo/Logo";
import TextField from "../textField/TextField";
import Checkbox from "../checkbox/Checkbox";
import Button from "../button/Button";
import PropTypes from "prop-types";
import Alert from "../alert/Alert";
import { Link } from "react-router-dom";

const LoginForm = ({onSubmit, error}) => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const validateEmail = () => {
    if(!email) {
      return 'Email is required';
    }
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(!regex.test(email)) {
      return 'Email is invalid';
    }
    return '';
  };

  const validatePassword = () => {
    if(!password) {
      return 'Password is required';
    }
    return '';
  }

  const hanldeLogin = () => {
    const emailValidationResult = validateEmail();
    const passwordValidationResult = validatePassword();
    
    setEmailError(emailValidationResult);
    setPasswordError(passwordValidationResult);

    if (emailValidationResult || passwordValidationResult) {
      return false;
    }

    onSubmit({
      email,
      password
    });
  };

  return (
    <div className={styles.container}>
      <Logo />
      <h1 className={styles.title}>Login to your Account</h1>
      { error && <Alert message={error} type="error" /> }
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          hanldeLogin();
        }}
      >
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(value) => setEmail(value)}
          error={emailError}
        />
        <TextField 
          label="Password"
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={(value) => setPassword(value)}
          error={passwordError}
        />
        <Checkbox
          label="Show Password"
          checked={showPassword}
          onChange={(value) => setShowPassword(value)}
        />
        <div className={styles.submit}>
          <Link to="/forgot-password" className={styles.forgotPassword}>Forgot Password?</Link>
          <Button
            label="Login"
            type="submit"
          />
        </div>
      </form>
    </div>
  );
};

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default LoginForm;
